import React from "react";

import { List, TextField, FunctionField, FilterButton, translate as translateHoc } from "jazasoft";

import Datagrid from "../../components/Datagrid";
import TooltipTextField from "../../components/TooltipTextField";

import SettingKeys from "../../utils/SettingKeys";
import { OState } from "../../utils/types";
import useQuery from "../../hooks/useQuery";
import filters from "../OrderFilter";
import { isEmpty } from "../../utils/helpers";
import { useSetting, useUnit } from "../../hooks";

const OrderStateValue = Object.keys(OState)
  .map(key => OState[key])
  .reduce((acc, e) => ({ ...acc, [e.state]: e.stateValue }), {});

const renderState = record => {
  const stateList = record?.states?.split(",");
  const state = stateList?.map(state => ({ state, value: OrderStateValue[state] })).sort((a, b) => a.value - b.value)[0]?.state;
  return state + `${stateList?.length > 1 ? "*" : ""}`;
};

const parse = ({ unitId, customerId, seasonId, productName, state }) => ({
  allocUnitIds: unitId === "all" ? unitId : !isEmpty(unitId) ? `*${unitId}*` : null,
  "customer.id": customerId,
  "season.id": seasonId,
  products: isEmpty(productName) ? null : `*${productName}*`,
  states: state
});

const CutPlanHome = props => {
  const { filterDefaultValues = {}, withState = true, ...restProps } = props;
  const { data: productList = [] } = useQuery({ url: "products", params: { size: 1000, sort: "name,asc" } });
  const orderFields = useSetting(SettingKeys.ENTITY_FIELDS, "orders");

  const { allUnitList } = useUnit();
  const unitChoices = [{ id: "all", name: "All Units" }, ...allUnitList.map(({ unitId, name }) => ({ id: unitId, name }))];

  const rowClick = (id, basePath, order) => {
    // const parentFlowInfoList = order.flowInfoList?.filter(fi => isEmpty(fi.parentId));

    // if (parentFlowInfoList?.length === 1) {
    //   props.history.push(`${basePath}/${id}/${parentFlowInfoList[0]?.id}`);
    // } else {
    //   props.history.push(`${basePath}/${id}`);
    // }

    props.history.push(`${basePath}/${id}`);
  };

  return (
    <List
      parse={parse}
      searchKeys={["poRef", "customerPoRef", "styles"]}
      filters={filters(withState, productList, unitChoices)}
      filterDefaultValues={filterDefaultValues}
      actions={({ resource }) => (
        <div>
          <FilterButton showLabel={false} resource={resource} />
        </div>
      )}
      {...restProps}>
      <Datagrid rowClick={rowClick}>
        {orderFields.includes("poRef") && <TooltipTextField source="poRef" label="resources.report.arr.excelColumns.poRef" />}
        {orderFields.includes("customer") && <TextField source="customer.name" label="resources.report.arr.excelColumns.customer" />}
        {orderFields.includes("products") && <TooltipTextField source="products" label="resources.report.arr.excelColumns.product" />}
        {orderFields.includes("styles") && <TooltipTextField source="styles" label="resources.report.arr.excelColumns.style" />}
        {orderFields.includes("season") && <TextField source="season.name" label="resources.report.arr.excelColumns.season" />}
        {orderFields.includes("orderQty") && <TextField source="orderQty" label="resources.report.arr.excelColumns.orderQty" />}
        {orderFields.includes("lines") && <TooltipTextField source="lines" label="resources.report.arr.excelColumns.line" />}
        {orderFields.includes("status") && <FunctionField render={renderState} label="resources.report.arr.excelColumns.status" />}
      </Datagrid>
    </List>
  );
};

export default translateHoc(CutPlanHome);
